import { type RecordType } from '@factorialco/f0-react/dist/experimental'
import { BenefitsEmployeeSelectorLegalEntityFragment } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'

import { TransactionCategory } from 'modules/benefits/lib/transactionCategories'
import { type EmployeeDetailsMap } from 'modules/benefits/pages/EmployeesPage/ActivationResultSidePanel'

export interface WizardData {
  employees_selected: EmployeeForSelectFragmentNoAccess[]
  employee_details_map: EmployeeDetailsMap
  spending_limits?: Partial<Record<TransactionCategory, number>>
}

export const Groups = {
  ALL: 'all',
  LEGAL_ENTITIES: 'legalEntities',
} as const

export type GroupType = (typeof Groups)[keyof typeof Groups]

export interface EntityBenefitSelectorProps {
  selectedEmployeeIds: EmployeeForSelectFragmentNoAccess[]
  setSelectedEmployeeIds: (employees: EmployeeForSelectFragmentNoAccess[]) => void
  selectedGroup: string
  setSelectedGroup: (group: string) => void
  expandedElements: number[]
  setExpandedElements: (elements: number[]) => void
  legalEntities: BenefitsEmployeeSelectorLegalEntityFragment[]
}

export interface SpendingLimitOverride extends RecordType {
  id: string
  employeeId: number
  employeeName: string
  employeeAvatar?: string
  amountCents: number
  category: TransactionCategory
}

export interface DefaultSpendingLimits {
  meals: number
  transportation: number
}
